<div [class]="classDate" placement="bottom" [autoClose]="'outside'" #p="ngbPopover" [ngbPopover]="dateTimePicker"
    class="input-group">
    <input #inputDateTime [(ngModel)]="_value"  class="form-control"
        placeholder="{{formItem?.placeholder}}" name="dp">
        <button class="input-group-text" type="button">
            <i class="feather icon-calendar icon-md text-muted"></i>
        </button>
</div>
<ng-template placement="right"  #dateTimePicker>
    <ngb-datepicker [(ngModel)]="date" (ngModelChange)="date=$event;" [minDate]="formItem?.minValue" [maxDate]="formItem?.maxValue" #createdStartDate
        name="datepicker" [ngModelOptions]="{standalone:true}"></ngb-datepicker>
    <ngb-timepicker [ngModel]="time" (ngModelChange)="time=$event;" #createdStartTime name="timepicker"
        [meridian]="true" [seconds]="true" [ngModelOptions]="{standalone:true}"></ngb-timepicker>
    <button class="btn btn-primary w-100" (click)="p.close();getDatetime()" type="button">
        {{'ok' | translate}}
    </button>
</ng-template>